import { useEffect } from 'react';

import { RunningExperiments, useExperiments } from 'state/experiments';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';

export const useDragonBallExperiment = (skipLoggingExposure: boolean = false) => {
  const { getVariantValue, logExposure } = useExperiments();

  const isCanada = region === Region.CA;
  const variantValue = isCanada
    ? undefined
    : getVariantValue(RunningExperiments.DragonBallAppTakeover)?.value;
  const canViewTakeover = isCanada || variantValue === 'treatment';

  useEffect(() => {
    if (skipLoggingExposure || !variantValue) {
      return;
    }

    logExposure(RunningExperiments.DragonBallAppTakeover);
  }, [logExposure, skipLoggingExposure, variantValue]);

  return canViewTakeover;
};
